<template>
  <div class="mb-5">
    <b-row>
      <b-col cols="12" class="mb-2">
        <h5 class="mb-0">{{ title }}</h5>
        <small class="text-muted">
          {{ subtitle }}
        </small>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="10">
        <b-form-group :label="$t('Endpoint that returns employees')" label-for="v-first-name">
          <b-form-input id="v-country-api-url" v-model="localLoginInfo.getEmployeesUrl"
            placeholder="https://api.example.com/employees" />
        </b-form-group>
      </b-col>
      <b-col cols="2" md="2">
        <b-form-group :label="$t('Click & Fetch')" label-for="v-first-name">
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" @click="fetchEmployees">
            {{ $t('Fetch') }}
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- <b-col cols="4" md="4">
        <small class="text-muted">
          {{ localLoginInfo.activeToken }}
        </small>
      </b-col> -->

      <b-row>
      <b-col cols="10">
        <b-alert variant="info" show class="mb-2">
          <div class="alert-body">
            <span><strong>{{ $t('Note') }}:</strong> {{ $t('The Save Changes button is only used to save the endpoint configuration') }}</span>
          </div>
        </b-alert>
      </b-col>
      <b-col cols="2" class="d-flex align-items-start">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-1"
          @click.prevent="sendInformation">
          {{ $t("Save Changes") }}
        </b-button>
      </b-col>
    </b-row>
    <b-col>
      <b-col v-if="importedEmployees">
        <b-card-code :code_visible="true" :title="$t('Response')">
          <b-card-text>
            <span>{{ $t('You can check the result from API') }} </span>
          </b-card-text>
          <template #code>
            {{ demoRequestResponse }}
          </template>
        </b-card-code>
      </b-col>
      <b-col>
        <b-card-code v-if="importedEmployees" :code_visible="false" :title="$t('Result')">
          <b-card-text>
            <b-alert v-if="importedEmployees" variant="success" show>
              <div class="alert-body">
                <span>
                  {{ $t('Employees matching your factory will be added from') }} <strong>{{ importedEmployees.length }}</strong> {{ $t('employees in the data') }}</span>
              </div>
            </b-alert>
            <b-button 
              v-ripple.400="'rgba(113, 102, 240, 0.15)'" 
              variant="outline-primary" 
              size="lg" 
              block 
              :disabled="isImporting"
              @click="importEmployees"
            >
              <b-spinner v-if="isImporting" small class="mr-1" />
              {{ isImporting ? $t('Importing...') : $t('Apply') }}
            </b-button>
            <small v-if="isImporting" class="text-muted d-block mt-1 text-center">
              {{ $t('This operation may take a while. Please wait...') }}
            </small>

          </b-card-text>
        </b-card-code>
      </b-col>
    </b-col>
    
  </div>
</template>


<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
  BAlert,
  BForm,
  BCardText,
  BBadge, BListGroup, BFormRadio, BListGroupItem,
  BSpinner
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CountryPicker from "../component/CountryPicker.vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "@axios";
import { heightTransition } from "@core/mixins/ui/transition";
import BCardCode from '@core/components/b-card-code'
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BButton,
    BCol,
    BFormGroup,
    BFormInput,
    BAlert,
    BForm,
    BCardText,
    BCardCode,
    vSelect,
    BFormRadio,
    CountryPicker, BBadge, BListGroup, BListGroupItem,
    BSpinner,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  mixins: [heightTransition],
  directives: {
    Ripple,
  },
  data() {
    return {
      selectedLanguage: "nothing_selected",
      selectedContry: "Turkey",
      requestMethod: "POST",
      useTokeninHeader: true,
      demoUser: "",
      demoPass: "",
      demoToken: null,
      localLoginInfo: {},

      //  {
      //     url:"",
      //     fetched:false,
      //     useCustomLogin:false,
      //    requestMethod:"POST",
      //     loginusername:"",
      //     loginpassword:"",
      //     useTokeninHeader:true,
      //     loginToken:"",
      //     authenticatedAccount:null,
      //     authenticatedAccountPass:null,
      //     additionalAuthAccountInfo:null,
      //     loginUrl:null,
      //     authLoginUrl:null, 
      //     useTokenInHeader:true,
      //     useTokenInQuery:false,
      //     tokenHeaderKey:null,

      //   },
      demoRequestResponse: "",
      requestMethods: ["GET", "POST", "PUT"],
      headers: {},
      importedEmployees: null,
      customCountryEndpoint: null,
      customCountryBase: "",
      selectedCountries: [],
      items:
      {

        "Content-Type": "application/json",


      },

      nextTodoId: 2,
      isImporting: false,

    };
  },
  props: {
    title: "",
    subtitle: "",
    description: "",
    sampleresponse: "",
    initialLoginInfo: {
      type: Object,
      default: () => { },
    },
  },
  methods: {

    sendInformation() {
      //console.log(this.localLoginInfo);


      this.isLoading = true;
      axios({
        method: "put",
        url: `/admin/f/migrationsettings`,
        data: {
          info: "getemployees",
          file: null,
          content: this.localLoginInfo,
        },
      })
        .then((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CheckCircleIcon",
              variant: "success",
            },
          });
          this.isLoading = false;
          this.isUpdated = false;
        })
        .catch((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "AlertOctagonIcon",
              variant: "warning",
            },
          });
          this.isLoading = false;
        });
      return;
    },

    validationForm() {
      return new Promise((resolve, reject) => {
        //console.log("validationForm");
        //console.log(this.selectedCountries.length);

        if (this.selectedCountries.length > 0) {
          resolve(true);
        } else {
          reject();
        }
      });
    },
    importEmployees() {
      this.isImporting = true;
      axios({
        method: "post",
        url: `/admin/f/createmigraterequest`,
        data: {
          info: "getemployees",
          file: null,
          content: this.localLoginInfo,
        },
      })
        .then((r) => {
          //console.log("Import Done");
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CheckCircleIcon",
              variant: "success",
            },
          });
          this.isImporting = false;
          this.isUpdated = false;
        })
        .catch((r) => {
          //console.log("Import Failed");
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "AlertOctagonIcon",
              variant: "warning",
            },
          });
          this.isImporting = false;
        });
      return;
    },

    async fetchEmployees() {
      var items = {
        "Content-Type": "application/json",
        "Authorization": this.localLoginInfo.activeToken
      };

      var uri = this.localLoginInfo.getEmployeesUrl;

      var options = {
        method: 'GET',
        headers: items,
      };

      try {
        const response = await fetch(uri, options);
        const data = await response.json();
        this.importedEmployees = data;
        this.demoRequestResponse = JSON.stringify(data, null, 2);
        return data;
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Error`,
            icon: "AlertOctagonIcon",
            variant: "warning",
          },
        });
      }
    },
    // fetchEmployees() {
    //   var items =
    //   {
    //     "Content-Type": "application/json",
    //     "Authorization": this.localLoginInfo.activeToken
    //   };
    //   return new Promise((resolve, reject) => {
    //     var uri = this.localLoginInfo.getEmployeesUrl;

    //     var options = {
    //       method: 'GET',
    //       headers: items,
    //     };

    //     const response = fetch(uri, options)
    //       .then((response) => {

    //         var data = response.json();
    //         console.log(data);
    //         return data;
    //       })
    //       .then((data) => {
    //         this.importedEmployees = data;
    //         this.demoRequestResponse = JSON.stringify(data);
    //         var respObject = JSON.parse(this.demoRequestResponse);
    //         this.demoToken = respObject.token;
    //         this.localLoginInfo.tokenExpireDate = respObject.tokenExpiration;
    //         this.localLoginInfo.activeToken = respObject.token;
    //         ;
    //         this.$emit("datafetched", this.demoToken);
    //         resolve(data);
    //       })
    //       .catch((error) => {
    //         //console.log(error);
    //         reject(error);
    //       });
    //   });
    // },

    countrySelected(value) {
      this.selectedCountries = value;
    },

    formSubmitted() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t("Form Submitted"),
          icon: "EditIcon",
          variant: "success",
        },
      });
    },
    repeateAgain() {
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
  },
  mounted() {
    //console.log("mounted");

    //  this.initTrHeight();
  },
  watch:
  {
    initialLoginInfo(newvalue, oldvalue) {
      //console.log("updated");
      //console.log( this.initialLoginInfo);
      //console.log(newvalue);

      this.localLoginInfo = this.initialLoginInfo == null ? {} : JSON.parse(JSON.stringify(this.initialLoginInfo.data));//this.generalData;


    }
  },
  created() {
    //console.log("Created");
    //console.log(this.initialLoginInfo);

    //  this.localLoginInfo = JSON.parse(JSON.stringify(this.initialLoginInfo));//this.generalData;
    this.localLoginInfo = this.initialLoginInfo == null ? {} : JSON.parse(JSON.stringify(this.initialLoginInfo));//this.generalData;

    window.addEventListener("resize", this.initTrHeight);

  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
};
</script>
